import React, { createContext, useContext, useState, useCallback } from 'react';
import { api, setToken, clearToken, isAuthenticated as checkAuth } from '../api/client';

type AuthState = {
  isAuthenticated: boolean;
  login: (password: string) => Promise<void>;
  logout: () => void;
};

const AuthContext = createContext<AuthState>({
  isAuthenticated: false,
  login: async () => {},
  logout: () => {},
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [authed, setAuthed] = useState(checkAuth());

  const login = useCallback(async (password: string) => {
    const result = await api.login(password);
    setToken(result.token);
    setAuthed(true);
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setAuthed(false);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated: authed, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
